import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { forwardRef } from 'react';
import { motion } from 'framer-motion';
import IconButton from '../Buttons/iconButton';
import { X } from 'lucide-react';
export function drawerSurfaceClasses({ fitHeight, fullHeight, portal, className, }) {
    return clsx('absolute bg-secondary-700 rounded-t-3xl bottom-0 left-0 right-0 z-50 text-primary-text ring-0! outline-hidden!', className, {
        'flex flex-col pb-4 h-full': !fitHeight,
        'flex flex-col': fitHeight,
        'border-none! rounded-none!': !fitHeight && fullHeight,
        'fixed! sm:absolute!': portal,
    });
}
export function drawerBodyClasses({ fitHeight, fullHeight, }) {
    return clsx('w-full px-4 styled-scroll', {
        'flex flex-col overflow-x-hidden relative': !fitHeight,
        'h-full': !fitHeight && !fullHeight,
        'flex-1 min-h-0': fullHeight,
        'pb-4': fitHeight,
    });
}
export function DrawerHeaderView({ title, close, }) {
    return (_jsxs("div", { className: "flex items-center w-full text-left justify-between px-4 sm:pt-2 pb-2", children: [title, close] }));
}
export const DrawerSurfaceView = forwardRef(function DrawerSurfaceView({ fitHeight, fullHeight, portal, className, ...props }, ref) {
    return (_jsx("div", { ...props, ref: ref, className: drawerSurfaceClasses({
            fitHeight,
            fullHeight,
            portal,
            className,
        }) }));
});
export const DrawerBodyView = forwardRef(function DrawerBodyView({ fitHeight, fullHeight, ...props }, ref) {
    return (_jsx("div", { ...props, ref: ref, className: drawerBodyClasses({ fitHeight, fullHeight }) }));
});
export const DrawerHeadingGroup = forwardRef(function DrawerHeadingGroup({ title, close, handle, description, snapPoints, handleMobileOnly }, ref) {
    return (_jsxs("div", { ref: ref, className: clsx('w-full flex-shrink-0', { relative: snapPoints }), children: [handle && (_jsx("div", { className: clsx('flex justify-center w-full mt-2 mb-[6px]', handleMobileOnly && 'sm:hidden'), children: handle })), (title || close) && (_jsx(DrawerHeaderView, { title: title, close: close })), description] }));
});
export const DrawerTitleView = forwardRef(function DrawerTitleView(props, ref) {
    return (_jsx("h3", { ...props, ref: ref, className: "text-lg text-secondary-text font-semibold w-full" }));
});
export const DrawerCloseButton = forwardRef(function DrawerCloseButton(props, ref) {
    return (_jsx("div", { ...props, ref: ref, children: _jsx(IconButton, { "aria-label": "Close modal", className: "inline-flex active:animate-press-down", icon: _jsx(X, { strokeWidth: 2 }) }) }));
});
export const DrawerHandleView = forwardRef(function DrawerHandleView({ children, ...props }, ref) {
    return (_jsx("div", { ref: ref, "data-vaul-handle": "", "aria-hidden": "true", ...props, children: _jsx("span", { "data-vaul-handle-hitarea": "", "aria-hidden": "true", children: children }) }));
});
export const DrawerBackdropView = forwardRef(function DrawerBackdropView(props, ref) {
    return (_jsx(motion.div, { ...props, ref: ref, className: "absolute inset-0 z-50 bg-black/50 block pointer-events-auto", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, transition: { duration: 0.3 } }));
});
